import {cls} from "./util.jsx";

export function ProgressBar({progress = '37.5%', settings: _settings = {}, className}) {

    return (
        <div>
            <div aria-hidden="true" className={cls('mt-2', className)}>
                <div className={cls("overflow-hidden rounded-full h-1.5", 'bg-gray-200')}>
                    <div style={{width: progress}} className="progress-bar-fill"/>
                </div>
            </div>
        </div>
    )
}